<template>
  <div>
    <v-card shaped v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        type="card-heading"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="mx-auto"
        type="image"
      ></v-skeleton-loader>
      <v-skeleton-loader
        v-for="i in 2" :key="i"
        class="mx-auto"
        type="list-item"
      ></v-skeleton-loader>
    </v-card>
    <v-card shaped v-else>
      <v-card-title>{{ title }}</v-card-title>
      <PieChart
        :series="this.pieData.series"
        :labels="this.pieData.labels"
        :width="450"
      />
      <v-card-text>
        <v-expansion-panels accordion flat>
          <v-expansion-panel v-for="(panel, i) in panels" :key="i">
            <v-expansion-panel-header>
              {{ panel.header }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <EmployeeTable
                :employees="panel.employees"
                :elevation="0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import EmployeeTable from '@/components/employee/Table'
  import PieChart from '@/components/chart/Pie'

  export default {
    name: 'DashboardPieCard',
    props: {
      loading: Boolean,
      title: String,
      pieData: Object,
      panels: Array
    },
    components: {
      EmployeeTable,
      PieChart
    },
  }
</script>
